import {
  ChargeSmallCard,
  ChargeSmallCardTitle,
} from "@/pages/profile/components/atom";
import styled from "styled-components";

export function PicturePriceCard({
  title,
  symbol,
  price,
  unit,
}: {
  title: string;
  symbol: string;
  price: number;
  unit: string;
}) {
  return (
    <SmallCard>
      <ContentArea>
        <ChargeSmallCardTitle>
          <span>{title}</span>
        </ChargeSmallCardTitle>
        <PriceArea>
          <span className="symbol">{symbol} </span>
          <span className="price">{price}</span>
          <span className="unit">{unit}</span>
        </PriceArea>
      </ContentArea>
    </SmallCard>
  );
}

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const PriceArea = styled.div`
  height: 14px;
  line-height: 14px;
  margin-top: 6px;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  .symbol {
    font-weight: normal;
    font-size: 10px;
    color: #d9dfe0;
  }
  .price {
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: #d9dfe0;
  }
  .unit {
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    margin-left: 6px;
  }

  // @media (max-width: 1440px) {
  //   display: flex;
  //   align-items: center;
  //   gap: 5px;
  // }
`;

const SmallCard = styled(ChargeSmallCard)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: unset !important;
  background: #292b2f;
  border: 1px solid #404246;
  border-radius: 4px;
  height: 64px;
  padding: 8px 12px;
`;
